import { Card, Col, Row } from 'antd';
import React from 'react';
import { cardsMock } from './Mock';
import { useHistory } from 'react-router-dom';

const DashboardWelcomeViewCards: React.FC = () => {
  const { Meta } = Card;
  const history = useHistory();

  return (
    <Row gutter={[16, 16]}>
      {cardsMock.map((item, index) => (
        <Col span={24} md={12} lg={8} key={index}>
          <Card
            hoverable
            style={{ borderRadius: '8px', minHeight: '190px' }}
            onClick={() => history.push(item.path)}
          >
            <Meta title={item.title} description={item.description} />
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default DashboardWelcomeViewCards;
